import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { AttentionResumenModel } from '../../models/consult/attention-resumen.model';


export class GetAttentionInProgressUseCase implements UseCase<{idCliente:string}, AttentionResumenModel> {
    constructor(private attention: ConsultRepository) { }
    execute(
        params: {idCliente: string},
    ): Observable<AttentionResumenModel> {
        return this.attention.getAttentionInProgress(params);
    }
}

